import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d2391482&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=d2391482&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2391482",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/home/csserver/project/jiankao/jiankao_admin_h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2391482')) {
      api.createRecord('d2391482', component.options)
    } else {
      api.reload('d2391482', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d2391482&scoped=true", function () {
      api.rerender('d2391482', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/PnTable/index.vue"
export default component.exports